module.exports = __webpack_public_path__ + "static/media/YB5F15_5.f96cb224.jpg";